
export const GAME_PC_BUTTON_WIDTH = '20px';
export const GAME_PC_BUTTON_HEIGHT = '20px';


export const GAME_MOBILE_BUTTON_WIDTH = '14px';
export const GAME_MOBILE_BUTTON_HEIGHT = '14px';